import React, { useState } from 'react';
import { X, Wallet, CheckCircle2, AlertCircle, TrendingUp, Maximize2 } from 'lucide-react';
import ContaPagarDetalhe from './ContaPagarDetalhe';

// Subcomponente interno com suporte opcional ao botão de expansão
function ModalStatBox({ title, icon: Icon, color, border, value, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* O botão só aparece se a função onExpand for fornecida */}
      {onExpand && (
        <button
          onClick={onExpand}
          className="absolute top-3 right-3 text-gray-600 hover:text-yellow-500 transition-colors z-20"
        >
          <Maximize2 size={18} />
        </button>
      )}

      <div className={`flex items-center gap-2 mb-4 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>
      <div>
        <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Valor Total</p>
        <p className={`font-mono text-2xl font-bold italic tracking-tighter ${color === 'text-yellow-500' ? 'text-white' : color}`}>
          {value}
        </p>
      </div>
    </div>
  );
}

export default function ContaPagarTotal({ data, onClose }) {
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  const formatBRL = (val) =>
    Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const aReceber = data?.aReceberMes || 0;
  const recebido = data?.recebidoMes || 0;

  const saldoEmAberto = recebido - aReceber;
  const percentual = recebido > 0 ? ((aReceber / recebido) * 100).toFixed(0) : 0;


  return (
    <>
      <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
        <div className="bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">

          {/* Cabeçalho */}
          <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
            <div className="flex items-center gap-2 text-yellow-500 font-bold tracking-widest text-xs uppercase">
              <Wallet size={18} />
              <span>Detalhamento Financeiro Recebimento (Mês)</span>
            </div>
            <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
              <X size={20} />
            </button>
          </div>

          {/* Conteúdo */}
          <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Adicionado o onExpand especificamente neste card */}
            <ModalStatBox
              title="Previsão Total a Receber"
              icon={Wallet}
              color="text-yellow-500"
              border="border-yellow-500"
              value={formatBRL(recebido)}
              onExpand={() => setIsDetailOpen(true)}
            />
            <ModalStatBox
              title="Total Recebido"
              icon={CheckCircle2}
              color="text-green-400"
              border="border-green-500"
              value={formatBRL(saldoEmAberto)}
              onExpand={() => setIsDetailOpen(true)}
            />

            <ModalStatBox
              title="Saldo em Aberto"
              icon={AlertCircle}
              color="text-red-400"
              border="border-red-500"
              value={formatBRL(aReceber)}
              onExpand={() => setIsDetailOpen(true)}
            />
            {/* Card de Eficiência */}
            <div className="bg-[#161b22] border-l-4 border-blue-500 p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]">
              <div className="flex items-center gap-2 mb-4 text-blue-400 font-black text-[10px] uppercase tracking-widest">
                <TrendingUp size={14} /> <span>Eficiência de Recebimento</span>
              </div>
              <div className="flex items-end gap-4">
                <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">{percentual}%</p>
                <div className="flex-1 bg-gray-900 h-2 rounded-full mb-2 overflow-hidden">
                  <div
                    className="bg-green-500 h-full shadow-[0_0_8px_#22c55e]"
                    style={{ width: `${percentual}%` }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Rodapé */}
          <div className="p-4 bg-[#0d1117] text-right border-t border-gray-800">
            <button
              onClick={onClose}
              className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-2 px-8 rounded transition-all uppercase tracking-widest shadow-lg"
            >
              Fechar Janela
            </button>
          </div>
        </div>
      </div>

      {/* Renderização condicional da nova tela ContaPagarDetalhe */}
      {isDetailOpen && (
        <ContaPagarDetalhe
          data={data}
          onClose={() => setIsDetailOpen(false)}
        />
      )}
    </>
  );
}